export function HudBrackets() {
  // Two L-shaped brackets per corner. Fixed viewport decoration, no animation.
  const stroke = "var(--color-cyan)";
  const opacity = 0.55;
  const common = {
    fill: "none" as const,
    stroke,
    strokeWidth: 1.5,
    strokeLinecap: "round" as const,
    opacity,
  };
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-30">
      <svg
        className="absolute left-0 top-0 h-12 w-12 sm:h-16 sm:w-16"
        viewBox="0 0 64 64"
      >
        <path d="M4 28 V8 H24" {...common} />
        <path d="M4 40 V20" {...common} opacity={opacity * 0.5} />
      </svg>
      <svg
        className="absolute right-0 top-0 h-12 w-12 sm:h-16 sm:w-16"
        viewBox="0 0 64 64"
      >
        <path d="M60 28 V8 H40" {...common} />
        <path d="M60 40 V20" {...common} opacity={opacity * 0.5} />
      </svg>
      <svg
        className="absolute bottom-0 left-0 h-12 w-12 sm:h-16 sm:w-16"
        viewBox="0 0 64 64"
      >
        <path d="M4 36 V56 H24" {...common} />
        <path d="M4 24 V44" {...common} opacity={opacity * 0.5} />
      </svg>
      <svg
        className="absolute bottom-0 right-0 h-12 w-12 sm:h-16 sm:w-16"
        viewBox="0 0 64 64"
      >
        <path d="M60 36 V56 H40" {...common} />
        <path d="M60 24 V44" {...common} opacity={opacity * 0.5} />
      </svg>
    </div>
  );
}